import { render, staticRenderFns } from "./VestingPercentInput.vue?vue&type=template&id=1f539196&"
import script from "./VestingPercentInput.vue?vue&type=script&lang=js&"
export * from "./VestingPercentInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports